import React, { Component } from 'react'
import MessageStatusView from './MessageStatusView';
import { checkTranslation, translate } from '../../../../utils/useful';


class MessageTextBox extends Component {
    render() {
        let data = this.props.data
        // console.log('this.props.data', this.props.data)
        return (
            <div className={'w-100 d-flex flex-column ' + (this.props.isOtherRef ? 'justify-content-start align-items-start' : 'justify-content-end align-items-end')}>
                <div className={"d-flex text-start " + (this.props.isOtherRef ? 'chatbox-other' : 'chatbox')} style={{ padding: '10px 10px', display: "flex", flexDirection: 'column', justifyContent: "center" }}>

                    {/* {console.log(String(this.props.showSenderInfo), this.props.chatUsers)} */}
                    {this.props.chatUsers && this.props.showSenderInfo && (
                        <div className="d-flex w-100">
                            <p className="font-size-12 text-semibold mb-0 main-cb w-100" style={{ textOverflow: 'ellipsis', overflow: 'hidden', }}>{this.props.chatUsers[data.senderHub]?.hub?.fullname}</p>
                        </div>
                    )}



                    <div className={'' + (!this.props.isOtherRef ? ' flexce' : ' flexc')}>
                        <p className={"text-semibold " + (this.props.isOtherRef ? 'chatbox-other-color' : 'chatbox-color')} style={{ fontSize: 14, overflowWrap: "anywhere", whiteSpace: "pre-wrap", direction: data.direction ?? 'ltr' }}>{checkTranslation(data.text)}</p>
                    </div>
                    {data.edited && (
                        <p className={"mt-1 " + (this.props.isOtherRef ? 'chatbox-other-color' : 'chatbox-color')} style={{ fontSize: 8, textAlign: "left", width: "100%" }}>{translate('messenger.Edited')}</p>
                    )}

                    <div className={"w-100 d-flex mt-0 " + (this.props.isOtherRef ? 'justify-content-start align-items-start' : 'justify-content-end align-items-end')}>
                        <div className="flexc">

                            {(this.props.showSelfSenderInfo && !this.props.isOtherRef && this.props.chatInteractive) && (
                                <div className="d-flex w-100 mrd-1">
                                    <p className="font-size-10   w-100" style={{ color: '#ffffffaa', textOverflow: 'ellipsis', overflow: 'hidden', }}>{this.props.senderIsMe ? translate("Me") : this.props.chatInteractive[data.sender]?.hub?.fullname} - </p>
                                </div>
                            )}

                            <p className='mrd-2' style={{ color: this.props.isOtherRef ? '#000000aa' : "#ffffffaa", fontSize: 10 }}>{checkTranslation(this.props.time)}</p>
                            {(!this.props.isOtherRef && !this.props.hideStatus) && (
                                <MessageStatusView status={data.status} colors={this.props.colors} iconColor="White" sentPadding={2} />
                            )}


                            {(this.props.showSelfSenderInfo && this.props.isOtherRef && this.props.chatInteractive) && (
                                <div className="d-flex w-100 mrd-1">
                                    <p className="font-size-10   w-100" style={{ color: '#000000aa', textOverflow: 'ellipsis', overflow: 'hidden', }}> - {this.props.senderIsMe ? translate("Me") : this.props.chatInteractive[data.sender]?.hub?.fullname}</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>


            </div>
        )
    }
}

export default MessageTextBox;